export type TranscriptSegment = {
  start?: number | null;
  end?: number | null;
  text: string;
  speaker?: string | null;
  approximate?: boolean;
};

export function recordingTimestamp(seconds: unknown): string {
  if (typeof seconds !== 'number' || !Number.isFinite(seconds) || seconds < 0) {
    return 'Zeitangabe offen';
  }
  return `${Math.floor(seconds / 60).toString().padStart(2, '0')}:${Math.floor(seconds % 60).toString().padStart(2, '0')}`;
}

export function recordingSegmentLabel(segment: TranscriptSegment): string {
  const time = recordingTimestamp(segment.start);
  const label = segment.approximate && time !== 'Zeitangabe offen'
    ? `Abschnitt ab ${time}` : time;
  return `${label}${segment.speaker ? ` · ${segment.speaker}` : ''}`;
}

// Check against the original media's loaded duration as well as stored data.
// Never coerce strings or turn an invalid timestamp into a real source location.
export function recordingSeekSeconds(start: unknown, duration: unknown): number | null {
  return typeof start === 'number' && Number.isFinite(start) && start >= 0 &&
    typeof duration === 'number' && Number.isFinite(duration) && duration > start
    ? start : null;
}
